import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m13.794 6.148-5.308 5.086c-.178.15-.344.211-.486.211a.7.7 0 0 1-.46-.186L2.205 6.15c-.267-.254-.275-.7-.02-.943a.663.663 0 0 1 .942-.02L8 9.856l4.872-4.666a.663.663 0 0 1 .942.02c.255.238.247.685-.02.938" }, null, -1)
  ]))]))
}
export default { render: render }